import React, {Component} from 'react';
import PicPopup from './preview-pic';

class ChatMsgListView extends  Component {
	static defaultProps = {
		list: [],
		resendMessage: function(){}
	}
	constructor(props){
		super(props);

		this.state = {
			list: props.list
		}
        this.size = props.list.length;
	}

	componentWillReceiveProps(nextProps) {
        this.setState({
            list: nextProps.list
        });
    }

	componentDidMount() {
        this.wrap = this.refs.wrap;

        this.scrollToBottom();
    }

	componentDidUpdate(prevProps, prevState){
        let newSize = this.state.list.length;
        let needToScrollToBottom = newSize !== this.size;

        needToScrollToBottom && this.scrollToBottom();

        this.size = newSize;
    }


    scrollToBottom() {
        let _height = this.wrap.scrollHeight - $(this.wrap).height();

        this.wrap.scrollTop = _height;
    }

    resendMessage(data) {
    	this.props.resendMessage(data);
    }

    previewPic(url){
       PicPopup.create({
            src: url
        });
    }

	render() {
		return (
			<div className="scroller" ref="wrap"> 
				<ul className="chat-list">
                { 
                    this.state.list.map((item, inx)=>{
                        let me = item.isSelf ? 'me' : 'friend';
                        let node;
                        let $loading;

                        if (item.isSelf) {
                            if (item.submiting == 1) {
                                $loading = <div className="loading"><i></i></div>;
                            } else if(item.submiting == -1) {
                                $loading = <div className="resend" onClick={this.resendMessage.bind(this, item)}><i></i></div>;
                            }
                        }

                        switch (item.msgType) {
                            case 'friendText':
                                return (
                                    <li className={me} key={inx} data-uid={item.oid}>
                                        <div className="message">
                                            <div className="avatar">
                                                <img src={item.avatar}/>
                                            </div>
                                            <div className="content">
                                                <div className="content-box">
                                                    <div className="text">
                                                        { item.content }
                                                    </div>
                                                    { $loading }
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                                break;
                            case 'friendPic':
                                return (
                                    <li className={me} key={inx} data-uid={item.oid}>
                                        <div className="message">
                                            <div className="avatar">
                                                <img src={item.avatar}/>
                                            </div>
                                            <div className="content">
                                                <div className="content-box">
                                                    <div className="pic">
                                                        <img src={item.origUrl} onLoad={()=>this.scrollToBottom()} onClick={this.previewPic.bind(this, item.origUrl)}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )
                                break;
                        }
                    })
                }
            	</ul>
			</div>
		)
	}
}

export default ChatMsgListView;


// WEBPACK FOOTER //
// ./js/im/views/chatmsg-list.js